export function useUAEPass() {
  //no-op for web
  return {
    isEnabled: false,
    login: async () => null,
    logout: async () => {},
    uaePassConfig: null,
  };
}
